/**
 * External dependencies
 */
import React from "react";
import { Table } from "antd";
import { map, size } from "lodash";

/**
 * Internal dependencies
 */
import {
  toTablePivotFormatter,
  formatMaybeDateString,
  resultSetToTimeZone,
} from "./utils";
import EmptyContent from "./base/empty-content";

/**
 * Style dependencies
 */
import "./table.scss";

const TableRenderer = ({
  resultSet,
  columnRenderer,
  columnConfig,
  tableProps,
}) => {
  // Get the table config from cube js, which includes formatting rules
  const tableColumnsConfig = resultSet.tableColumns();
  const timezone = resultSetToTimeZone(resultSet);

  let tableColumns = null;
  if (columnConfig) {
    tableColumns = columnConfig;
  } else {
    // add more relevent data
    tableColumns = map(tableColumnsConfig, ({ shortTitle, ...r }) => {
      return {
        ...r,
        title: formatMaybeDateString(shortTitle, "MMM D, YYYY"),
        render: (value, row) => {
          if (columnRenderer) {
            return columnRenderer({
              value,
              formattedValue: toTablePivotFormatter(r)(value, row, {
                timezone,
              }),
              column: r,
              row,
            });
          }
          return toTablePivotFormatter(r)(value, row);
        },
        sorter:
          r.type === "number"
            ? (a, b) => {
                return a[r.key] - b[r.key];
              }
            : null,
        align: r.type === "number" ? "right" : "left",
      };
    });
  }

  const data = map(resultSet.tablePivot(), (r, key) => ({ key, ...r }));

  if (size(data) === 0) {
    return <EmptyContent />;
  }

  return (
    <Table
      className="charts__table"
      pagination={false}
      size="middle"
      columns={tableColumns}
      dataSource={data}
      {...tableProps}
    />
  );
};

export default TableRenderer;
